interface SpinnerProps {
    size?: 'sm' | 'md' | 'lg'
    color?: 'current' | 'primary' | 'white'
    className?: string
}

export function Spinner({ size = 'md', color = 'current', className = '' }: SpinnerProps) {
    const sizeClasses = {
        sm: 'w-4 h-4 border-2',
        md: 'w-8 h-8 border-4',
        lg: 'w-12 h-12 border-4',
    }

    const colorClasses = {
        current: 'border-current',
        primary: 'border-primary',
        white: 'border-white',
    }

    return (
        <div
            className={`
                ${sizeClasses[size]} 
                ${colorClasses[color]} 
                border-t-transparent 
                rounded-full 
                animate-spin 
                ${className}
            `}
        />
    )
}
